import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MaterialCustomModule } from 'v2/material-custom.module';
import { FilterModule } from 'v2/modules/filter/filter.module';
import { PipeModule } from 'v2/modules/shared/pipes/pipe.module';
import { UiModule } from 'v2/modules/ui/ui.module';
import { FeatureModule } from 'v2/shared/feature/feature.module';
import { SharedComponentsModule } from 'v2/shared-components.module';

import { ClientProfileAddShippingAddressFormComponent } from './components/client-profile-add-shipping-address-form/client-profile-add-shipping-address-form.component';
import { ClientProfileBusinessAddressFormComponent } from './components/client-profile-business-address-form/client-profile-business-address-form.component';
import { ClientProfileCreateComponent } from './components/client-profile-create/client-profile-create.component';
import { ClientProfileDialogComponent } from './components/client-profile-dialog/client-profile-dialog.component';
import { ClientProfileEditShippingAddressFormComponent } from './components/client-profile-edit-shipping-address-form/client-profile-edit-shipping-address-form.component';
import { ClientProfileInfoFormComponent } from './components/client-profile-info-form/client-profile-info-form.component';
import { ClientProfileShippingAddressFormComponent } from './components/client-profile-shipping-address-form/client-profile-shipping-address-form.component';

const COMPONENTS_PUBLIC = [
  ClientProfileCreateComponent,
  ClientProfileDialogComponent,
];

const MODULES_ANGULAR = [CommonModule, FormsModule, ReactiveFormsModule];
const MODULES_VENDOR = [];
const MODULES_LUM = [
  FilterModule,
  MaterialCustomModule,
  PipeModule,
  FeatureModule,
  SharedComponentsModule,
  UiModule,
];

@NgModule({
  declarations: [
    ClientProfileAddShippingAddressFormComponent,
    ClientProfileBusinessAddressFormComponent,
    ClientProfileEditShippingAddressFormComponent,
    ClientProfileInfoFormComponent,
    ClientProfileShippingAddressFormComponent,
    ...COMPONENTS_PUBLIC,
  ],
  imports: [...MODULES_ANGULAR, ...MODULES_VENDOR, ...MODULES_LUM],
  exports: [...COMPONENTS_PUBLIC],
})
export class ClientProfileModule {}
